(function() {
  const root = document.querySelector('.bbdemo');
  if (!root) return;

  const animEls = root.querySelectorAll('.bbdemo-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });
    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('is-visible'); });
  }

  let cfg = {};
  try {
    const cfgRaw = root.getAttribute('data-bbdemo-config');
    if (cfgRaw) cfg = JSON.parse(cfgRaw);
  } catch (e) { cfg = {}; }

  function imgHtml(key, alt) {
    const url = cfg[key];
    if (!url) return '';
    return '<img src="' + url + '" alt="' + (alt || '') + '" decoding="async">';
  }

  const products = [
    { id: 'box-classic', step: 1, name: 'Classic Gift Box', meta: 'Kraft, Reusable', desc: 'A timeless natural box that pairs with anything inside.', img: imgHtml('img_box_classic', 'Classic Gift Box'), tags: ['classic'], max: 1 },
    { id: 'box-birthday', step: 1, name: 'Birthday Gift Box', meta: 'Festive, Vibrant', desc: 'Bright colours and a celebratory feel.', img: imgHtml('img_box_birthday', 'Birthday Gift Box'), tags: ['birthday'], max: 1 },
    { id: 'box-thanks', step: 1, name: 'Thank You Gift Box', meta: 'Warm, Heartfelt', desc: 'Perfect for showing appreciation.', img: imgHtml('img_box_thanks', 'Thank You Gift Box'), tags: ['thanks'], max: 1 },
    { id: 'box-getwell', step: 1, name: 'Get Well Soon Gift Box', meta: 'Soft, Calming', desc: 'A comforting design for someone recovering.', img: imgHtml('img_box_getwell', 'Get Well Soon Gift Box'), tags: ['getwell'], max: 1 },

    { id: 'salted-caramel', step: 2, name: 'Salted Caramel Fudge', meta: 'Bestseller', desc: 'Buttery fudge with flakes of sea salt.', img: imgHtml('img_salted_caramel', 'Salted Caramel Fudge'), tags: ['vegan'], max: 4 },
    { id: 'dark-choc', step: 2, name: 'Dark Chocolate Fudge', meta: '70% cocoa', desc: 'Rich dark chocolate, intensely smooth.', img: imgHtml('img_dark_choc', 'Dark Chocolate Fudge'), tags: ['vegan', 'gluten-free'], max: 4 },
    { id: 'vanilla-butter', step: 2, name: 'Vanilla Butter Fudge', meta: 'Madagascan vanilla', desc: 'Classic creamy fudge with Madagascan vanilla.', img: imgHtml('img_vanilla_butter', 'Vanilla Butter Fudge'), tags: ['gluten-free'], max: 4 },
    { id: 'peanut-crunch', step: 2, name: 'Peanut Crunch Fudge', meta: 'Crunchy', desc: 'Soft fudge studded with peanut brittle.', img: imgHtml('img_peanut_crunch', 'Peanut Crunch Fudge'), tags: ['nutty'], max: 4 },
    { id: 'cookies-cream', step: 2, name: 'Cookies & Cream Bites', meta: 'Sharing pack', desc: 'Cookie pieces wrapped in white chocolate.', img: imgHtml('img_cookies_cream', 'Cookies & Cream Bites'), tags: ['vegan'], max: 4 },
    { id: 'hazelnut-truffles', step: 2, name: 'Hazelnut Truffles', meta: 'Hand-rolled', desc: 'Hand-rolled truffles with toasted hazelnut.', img: imgHtml('img_hazelnut_truffles', 'Hazelnut Truffles'), tags: ['gluten-free', 'nutty'], max: 4 },

    { id: 'gift-card', step: 3, name: 'Gift Card', meta: 'Personal touch', desc: 'A handwritten gift card with your message.', img: imgHtml('img_gift_card', 'Gift Card'), tags: [], max: 1 },
    { id: 'ribbon', step: 3, name: 'Ribbon Upgrade', meta: 'Premium silk', desc: 'Premium silk ribbon in your chosen colour.', img: imgHtml('img_ribbon', 'Ribbon Upgrade'), tags: [], max: 1 },
    { id: 'candle', step: 3, name: 'Mini Candle', meta: 'Hand-poured', desc: 'A small soy wax candle, lavender scent.', img: imgHtml('img_candle', 'Mini Candle'), tags: [], max: 1 },
    { id: 'extra-bag', step: 3, name: 'Extra Treat Bag', meta: '4 minis', desc: 'A bonus bag of mini treats to share.', img: imgHtml('img_extra_bag', 'Extra Treat Bag'), tags: [], max: 1 },
    { id: 'sticker', step: 3, name: 'Greeting Sticker', meta: 'Wax-style seal', desc: 'A custom wax-style seal on the box.', img: imgHtml('img_sticker', 'Greeting Sticker'), tags: [], max: 1 },
    { id: 'surprise', step: 3, name: 'Surprise Add-on', meta: 'Sweet bonus', desc: 'A random sweet bonus from our stash.', img: imgHtml('img_surprise', 'Surprise Add-on'), tags: [], max: 1 }
  ];

  const state = {
    currentStep: 1,
    selectedTier: { qty: 6, discount: 10 },
    selectedBox: null,
    treats: new Map(),
    extras: new Map(),
    isGift: false,
    giftBox: { id: 'standard', name: 'Standard Gift Box', price: 0 },
    giftRecipient: '',
    giftMessage: '',
    basePrice: 35.00,
    activeFilter: 'all'
  };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  const grid = $('[data-bbdemo-grid]');

  function updateProductCards() {
    if (!grid) return;
    grid.querySelectorAll('.bbdemo__card').forEach(function(card) {
      const id = card.dataset.id;
      const isSel = isSelected(id);
      const qty = getQty(id);
      card.classList.toggle('is-on', isSel);
      const qtySpan = card.querySelector('.bbdemo__card-qty span');
      if (qtySpan) qtySpan.textContent = qty || 1;
    });
  }

  function renderProducts() {
    if (!grid) return;
    grid.innerHTML = '';
    const stepProducts = products.filter(p => p.step === state.currentStep);
    stepProducts.forEach(p => {
      const isSel = isSelected(p.id);
      const qty = getQty(p.id);
      const card = document.createElement('div');
      card.className = 'bbdemo__card' + (isSel ? ' is-on' : '');
      card.dataset.id = p.id;
      card.dataset.step = p.step;
      card.dataset.tags = p.tags.join(',');
      card.innerHTML =
        '<div class="bbdemo__card-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></div>' +
        '<div class="bbdemo__card-img">' + p.img + '</div>' +
        '<div class="bbdemo__card-name">' + p.name + '</div>' +
        '<div class="bbdemo__card-meta">' + p.meta + '</div>' +
        '<div class="bbdemo__card-desc">' + p.desc + '</div>' +
        (p.step === 2 ? '<div class="bbdemo__card-max">Max: ' + p.max + '</div>' : '') +
        '<button type="button" class="bbdemo__card-select">Select</button>' +
        '<div class="bbdemo__card-qty">' +
          '<button type="button" data-act="minus">−</button>' +
          '<span>' + (qty || 1) + '</span>' +
          '<button type="button" data-act="plus">+</button>' +
        '</div>';
      grid.appendChild(card);
    });
    applyFilter();
  }

  function isSelected(id) {
    const p = products.find(x => x.id === id);
    if (!p) return false;
    if (p.step === 1) return state.selectedBox === id;
    if (p.step === 2) return state.treats.has(id);
    if (p.step === 3) return state.extras.has(id);
    return false;
  }

  function getQty(id) {
    const p = products.find(x => x.id === id);
    if (!p) return 0;
    if (p.step === 1) return state.selectedBox === id ? 1 : 0;
    if (p.step === 2) return state.treats.get(id) || 0;
    if (p.step === 3) return state.extras.has(id) ? 1 : 0;
    return 0;
  }

  function getTreatsTotal() {
    let t = 0;
    state.treats.forEach(q => t += q);
    return t;
  }

  if (grid) {
    grid.addEventListener('click', e => {
      const card = e.target.closest('.bbdemo__card');
      if (!card) return;
      const p = products.find(x => x.id === card.dataset.id);
      if (!p) return;
      if (e.target.closest('.bbdemo__card-select')) {
        selectProduct(p);
      } else if (e.target.dataset.act === 'minus') {
        e.stopPropagation();
        changeQty(p, -1);
      } else if (e.target.dataset.act === 'plus') {
        e.stopPropagation();
        changeQty(p, 1);
      }
    });
  }

  function selectProduct(p) {
    if (p.step === 1) {
      state.selectedBox = p.id;
      setTimeout(function() {
        if (state.currentStep === 1) goToStep(2);
      }, 250);
      showToast('Box chosen, pick your treats next', 'success');
    } else if (p.step === 2) {
      const total = getTreatsTotal();
      if (total >= state.selectedTier.qty) {
        showToast('Max ' + state.selectedTier.qty + ' treats for this tier', 'warning');
        return;
      }
      state.treats.set(p.id, 1);
    } else if (p.step === 3) {
      state.extras.set(p.id, 1);
    }
    update();
  }

  function changeQty(p, delta) {
    if (p.step === 2) {
      const cur = state.treats.get(p.id) || 0;
      const next = cur + delta;
      const total = getTreatsTotal();
      if (next <= 0) {
        state.treats.delete(p.id);
      } else if (next > p.max) {
        showToast('Max ' + p.max + ' of this treat', 'warning');
        return;
      } else if (delta > 0 && total >= state.selectedTier.qty) {
        showToast('Bundle full, ' + state.selectedTier.qty + ' treats max', 'warning');
        return;
      } else {
        state.treats.set(p.id, next);
      }
    } else if (p.step === 1 && delta < 0) {
      state.selectedBox = null;
    } else if (p.step === 3 && delta < 0) {
      state.extras.delete(p.id);
    }
    update();
  }

  function removeProduct(id) {
    const p = products.find(x => x.id === id);
    if (!p) return;
    if (p.step === 1) state.selectedBox = null;
    if (p.step === 2) state.treats.delete(id);
    if (p.step === 3) state.extras.delete(id);
    update();
  }

  function goToStep(n) {
    state.currentStep = n;
    $$('[data-bbdemo-step]').forEach(el => {
      const stepNum = parseInt(el.dataset.bbdemoStep);
      el.classList.remove('bbdemo__step--active', 'bbdemo__step--completed');
      if (stepNum === n) el.classList.add('bbdemo__step--active');
      if (stepHasSelection(stepNum)) el.classList.add('bbdemo__step--completed');
    });
    $$('[data-bbdemo-line]').forEach(line => {
      const num = parseInt(line.dataset.bbdemoLine);
      line.classList.toggle('bbdemo__step-line--completed', stepHasSelection(num));
    });
    const filters = $('[data-bbdemo-filters]');
    if (filters) filters.style.display = n === 2 ? 'flex' : 'none';
    renderProducts();
  }

  function stepHasSelection(n) {
    if (n === 1) return state.selectedBox !== null;
    if (n === 2) return state.treats.size > 0;
    if (n === 3) return state.extras.size > 0;
    return false;
  }

  $$('[data-bbdemo-step]').forEach(el => {
    el.addEventListener('click', () => {
      const n = parseInt(el.dataset.bbdemoStep);
      goToStep(n);
    });
  });

  $$('[data-bbdemo-filter]').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('[data-bbdemo-filter]').forEach(b => b.classList.remove('is-on'));
      btn.classList.add('is-on');
      state.activeFilter = btn.dataset.bbdemoFilter;
      applyFilter();
    });
  });

  function applyFilter() {
    if (state.currentStep !== 2) return;
    $$('.bbdemo__card').forEach(card => {
      if (state.activeFilter === 'all') {
        card.classList.remove('is-hidden');
      } else {
        const tags = (card.dataset.tags || '').split(',');
        card.classList.toggle('is-hidden', !tags.includes(state.activeFilter));
      }
    });
  }

  $$('[data-bbdemo-tier]').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('[data-bbdemo-tier]').forEach(b => b.classList.remove('is-on'));
      btn.classList.add('is-on');
      state.selectedTier = {
        qty: parseInt(btn.dataset.qty),
        discount: parseInt(btn.dataset.discount)
      };
      let total = getTreatsTotal();
      if (total > state.selectedTier.qty) {
        const entries = Array.from(state.treats.entries()).reverse();
        for (const [id] of entries) {
          while (total > state.selectedTier.qty && state.treats.get(id) > 0) {
            const cur = state.treats.get(id);
            if (cur <= 1) state.treats.delete(id);
            else state.treats.set(id, cur - 1);
            total--;
          }
          if (total <= state.selectedTier.qty) break;
        }
      }
      update();
    });
  });

  function update() {
    const treatsTotal = getTreatsTotal();
    const limit = state.selectedTier.qty;

    const countEl = $('[data-bbdemo-count]');
    const limitEl = $('[data-bbdemo-limit]');
    if (countEl) countEl.textContent = treatsTotal;
    if (limitEl) limitEl.textContent = limit;

    const pct = Math.min(100, (treatsTotal / limit) * 100);
    const fill = $('[data-bbdemo-progress-fill]');
    if (fill) fill.style.width = pct + '%';

    const msgEl = $('[data-bbdemo-progress-msg]');
    if (msgEl) {
      msgEl.classList.remove('is-complete');
      if (!state.selectedBox) {
        msgEl.textContent = 'Choose your box first';
      } else if (treatsTotal === 0) {
        msgEl.textContent = 'Pick ' + limit + ' treats to fill your bundle';
      } else if (treatsTotal < limit) {
        const need = limit - treatsTotal;
        msgEl.textContent = 'Add ' + need + ' more treat' + (need !== 1 ? 's' : '') + ' to unlock ' + state.selectedTier.discount + '% off';
      } else {
        msgEl.textContent = 'Bundle complete, ' + state.selectedTier.discount + '% off unlocked';
        msgEl.classList.add('is-complete');
      }
    }

    renderItems();

    $$('[data-bbdemo-step]').forEach(el => {
      const n = parseInt(el.dataset.bbdemoStep);
      el.classList.toggle('bbdemo__step--completed', stepHasSelection(n));
      el.classList.toggle('bbdemo__step--active', n === state.currentStep);
    });
    $$('[data-bbdemo-line]').forEach(line => {
      const num = parseInt(line.dataset.bbdemoLine);
      line.classList.toggle('bbdemo__step-line--completed', stepHasSelection(num));
    });

    updateProductCards();

    let price = state.basePrice * (limit / 6);
    let original = price;
    const discount = state.selectedTier.discount;
    if (treatsTotal === limit && state.selectedBox) {
      price = original * (1 - discount / 100);
    }

    const priceEl = $('[data-bbdemo-price]');
    const strikeEl = $('[data-bbdemo-strike]');
    const badgeEl = $('[data-bbdemo-discount-badge]');
    const savingsEl = $('[data-bbdemo-savings]');
    const savingsAmtEl = $('[data-bbdemo-savings-amt]');

    if (priceEl) priceEl.textContent = '£' + price.toFixed(2);
    if (treatsTotal === limit && state.selectedBox) {
      if (strikeEl) { strikeEl.textContent = '£' + original.toFixed(2); strikeEl.classList.remove('is-hidden'); }
      if (badgeEl) { badgeEl.textContent = discount + '% off'; badgeEl.classList.remove('is-hidden'); }
      if (savingsAmtEl) savingsAmtEl.textContent = '£' + (original - price).toFixed(2);
      if (savingsEl) savingsEl.classList.remove('is-hidden');
    } else {
      if (strikeEl) strikeEl.classList.add('is-hidden');
      if (badgeEl) badgeEl.classList.add('is-hidden');
      if (savingsEl) savingsEl.classList.add('is-hidden');
    }

    const status = $('[data-bbdemo-status]');
    const statusText = $('[data-bbdemo-status-text]');
    const isComplete = state.selectedBox && treatsTotal === limit;
    if (status) {
      status.classList.toggle('is-complete', isComplete);
      const ic = status.querySelector('.bbdemo__status-icon');
      if (ic) {
        ic.innerHTML = isComplete ? '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' : '!';
      }
    }
    if (statusText) {
      if (!state.selectedBox) statusText.textContent = 'Choose your box first.';
      else if (treatsTotal < limit) statusText.textContent = 'Add ' + (limit - treatsTotal) + ' more treat' + (limit - treatsTotal !== 1 ? 's' : '') + ' to complete.';
      else statusText.textContent = 'Bundle complete, ready to add.';
    }

    const addBtn = $('[data-bbdemo-add]');
    if (addBtn) {
      addBtn.classList.toggle('is-enabled', isComplete);
      addBtn.disabled = !isComplete;
    }

    const mobileCount = $('[data-bbdemo-mobile-count]');
    const mobileLabel = $('[data-bbdemo-mobile-label]');
    const mobilePrice = $('[data-bbdemo-mobile-price]');
    const totalSelected = (state.selectedBox ? 1 : 0) + treatsTotal + state.extras.size;
    let labelText;
    if (!state.selectedBox) labelText = 'Tap to start your bundle';
    else if (treatsTotal < limit) labelText = 'Tap to view (' + treatsTotal + '/' + limit + ')';
    else labelText = 'Bundle complete, tap to add';
    if (mobileCount) mobileCount.textContent = totalSelected;
    if (mobileLabel) mobileLabel.textContent = labelText;
    if (mobilePrice) mobilePrice.textContent = '£' + price.toFixed(2);

    updateGiftSummary();
  }

  function renderItems() {
    const items = $('[data-bbdemo-items]');
    if (!items) return;
    const all = [];
    if (state.selectedBox) {
      const p = products.find(x => x.id === state.selectedBox);
      if (p) all.push({ p: p, qty: 1 });
    }
    state.treats.forEach((qty, id) => {
      const p = products.find(x => x.id === id);
      if (p) all.push({ p: p, qty: qty });
    });
    state.extras.forEach((qty, id) => {
      const p = products.find(x => x.id === id);
      if (p) all.push({ p: p, qty: qty });
    });

    if (all.length === 0) {
      items.innerHTML = '<div class="bbdemo__items-empty">Your bundle is empty.<br>Pick a box to get started.</div>';
      return;
    }

    items.innerHTML = all.map(({ p, qty }) =>
      '<div class="bbdemo__item">' +
        '<div class="bbdemo__item-thumb">' + p.img + '</div>' +
        '<div class="bbdemo__item-info">' +
          '<div class="bbdemo__item-name">' + p.name + '</div>' +
          '<div class="bbdemo__item-controls">' +
            (p.step === 2
              ? '<button type="button" class="bbdemo__item-qty-btn" data-act="minus" data-id="' + p.id + '">−</button><span class="bbdemo__item-qty-val">' + qty + '</span><button type="button" class="bbdemo__item-qty-btn" data-act="plus" data-id="' + p.id + '">+</button>'
              : '<span class="bbdemo__item-qty-val">×' + qty + '</span>'
            ) +
          '</div>' +
        '</div>' +
        '<button type="button" class="bbdemo__item-remove" data-id="' + p.id + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>' +
      '</div>'
    ).join('');

    items.querySelectorAll('.bbdemo__item-remove').forEach(b => {
      b.addEventListener('click', () => removeProduct(b.dataset.id));
    });
    items.querySelectorAll('.bbdemo__item-qty-btn').forEach(b => {
      b.addEventListener('click', () => {
        const p = products.find(x => x.id === b.dataset.id);
        const delta = b.dataset.act === 'plus' ? 1 : -1;
        changeQty(p, delta);
      });
    });
  }

  const giftCheck = $('[data-bbdemo-gift-check]');
  const giftLabel = $('[data-bbdemo-gift-label]');
  function tryOpenGift() {
    if (!state.selectedBox || getTreatsTotal() < state.selectedTier.qty) {
      showToast('Complete your bundle first', 'warning');
      return;
    }
    openGiftPopup();
  }
  if (giftCheck) giftCheck.addEventListener('click', tryOpenGift);
  if (giftLabel) giftLabel.addEventListener('click', tryOpenGift);

  function openGiftPopup() {
    const overlay = $('[data-bbdemo-gp-overlay]');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
  function closeGiftPopup() {
    const overlay = $('[data-bbdemo-gp-overlay]');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
  const gpClose = $('[data-bbdemo-gp-close]');
  if (gpClose) gpClose.addEventListener('click', closeGiftPopup);
  const gpOverlay = $('[data-bbdemo-gp-overlay]');
  if (gpOverlay) {
    gpOverlay.addEventListener('click', e => {
      if (e.target === gpOverlay) closeGiftPopup();
    });
  }

  const gpCheck = $('[data-bbdemo-gp-check]');
  const gpFields = $('[data-bbdemo-gp-fields]');
  const gpLabel = $('[data-bbdemo-gp-checkbox-label]');
  function toggleGpCheck() {
    if (!gpCheck || !gpFields) return;
    gpCheck.classList.toggle('is-on');
    gpFields.classList.toggle('is-hidden', !gpCheck.classList.contains('is-on'));
  }
  if (gpCheck) gpCheck.addEventListener('click', toggleGpCheck);
  if (gpLabel) gpLabel.addEventListener('click', toggleGpCheck);

  $$('[data-bbdemo-gp-card]').forEach(card => {
    card.addEventListener('click', () => {
      $$('[data-bbdemo-gp-card]').forEach(c => {
        c.classList.remove('is-on');
        const btn = c.querySelector('.bbdemo__gp-card-btn');
        if (btn) btn.textContent = 'Select';
      });
      card.classList.add('is-on');
      const btn = card.querySelector('.bbdemo__gp-card-btn');
      if (btn) btn.textContent = 'Selected';
      updateGpTotal();
    });
  });

  function updateGpTotal() {
    const selected = root.querySelector('[data-bbdemo-gp-card].is-on');
    const giftPrice = selected ? parseFloat(selected.dataset.price) : 0;
    const treatsTotal = getTreatsTotal();
    const limit = state.selectedTier.qty;
    let price = state.basePrice * (limit / 6);
    if (treatsTotal === limit && state.selectedBox) {
      price = price * (1 - state.selectedTier.discount / 100);
    }
    const total = price + giftPrice;
    const totalEl = $('[data-bbdemo-gp-total]');
    if (totalEl) totalEl.textContent = '£' + total.toFixed(2);
    const status = $('[data-bbdemo-gp-status]');
    if (status) {
      if (selected) {
        status.textContent = selected.dataset.name + ' selected';
        status.classList.add('is-ok');
      } else {
        status.textContent = 'Select a gift box option';
        status.classList.remove('is-ok');
      }
    }
  }

  const gpApply = $('[data-bbdemo-gp-apply]');
  if (gpApply) {
    gpApply.addEventListener('click', () => {
      const selected = root.querySelector('[data-bbdemo-gp-card].is-on');
      if (!selected) {
        showToast('Pick a gift box option', 'warning');
        return;
      }
      state.isGift = gpCheck && gpCheck.classList.contains('is-on');
      state.giftBox = {
        id: selected.dataset.id,
        name: selected.dataset.name,
        price: parseFloat(selected.dataset.price)
      };
      const recipientEl = $('[data-bbdemo-gp-recipient]');
      const messageEl = $('[data-bbdemo-gp-message]');
      state.giftRecipient = recipientEl ? recipientEl.value : '';
      state.giftMessage = messageEl ? messageEl.value : '';
      if (giftCheck) giftCheck.classList.add('is-on');
      closeGiftPopup();
      update();
      showToast('Gift options applied', 'success');
    });
  }

  const gpSkip = $('[data-bbdemo-gp-skip]');
  if (gpSkip) {
    gpSkip.addEventListener('click', () => {
      state.isGift = false;
      state.giftBox = { id: 'standard', name: 'Standard Gift Box', price: 0 };
      state.giftRecipient = '';
      state.giftMessage = '';
      if (giftCheck) giftCheck.classList.remove('is-on');
      closeGiftPopup();
      update();
    });
  }

  function updateGiftSummary() {
    const summary = $('[data-bbdemo-gift-summary]');
    if (!summary) return;
    if (state.isGift && state.giftBox.id !== 'standard') {
      summary.classList.add('is-on');
      summary.innerHTML = '<b>' + state.giftBox.name + '</b>' + (state.giftRecipient ? ' For: ' + state.giftRecipient : '');
    } else if (state.isGift) {
      summary.classList.add('is-on');
      summary.innerHTML = '<b>Gift options applied</b>' + (state.giftRecipient ? ' For: ' + state.giftRecipient : '');
    } else {
      summary.classList.remove('is-on');
    }
    if (giftCheck) giftCheck.classList.toggle('is-on', state.isGift);
  }

  const addBtn = $('[data-bbdemo-add]');
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (addBtn.disabled) return;
      openCartDrawer();
    });
  }

  function openCartDrawer() {
    const props = [];
    if (state.selectedBox) {
      const box = products.find(x => x.id === state.selectedBox);
      props.push({ key: 'Box', val: box.name });
    }
    let i = 1;
    state.treats.forEach((qty, id) => {
      const p = products.find(x => x.id === id);
      props.push({ key: 'Treat ' + i, val: p.name + ' ×' + qty });
      i++;
    });
    state.extras.forEach((qty, id) => {
      const p = products.find(x => x.id === id);
      props.push({ key: 'Add-on', val: p.name });
    });
    if (state.giftBox && state.giftBox.id !== 'standard') {
      props.push({ key: 'Gift box', val: state.giftBox.name });
    }
    if (state.isGift && state.giftRecipient) {
      props.push({ key: 'Recipient', val: state.giftRecipient });
    }
    if (state.isGift && state.giftMessage) {
      props.push({ key: 'Message', val: state.giftMessage });
    }

    const propsEl = $('[data-bbdemo-cd-props]');
    if (propsEl) {
      propsEl.innerHTML = props.map(p =>
        '<div class="bbdemo__cd-prop"><span class="key">' + p.key + '</span><span class="val">' + p.val + '</span></div>'
      ).join('');
    }

    const tierEl = $('[data-bbdemo-cd-tier]');
    if (tierEl) tierEl.textContent = 'Box of ' + state.selectedTier.qty + ' · ' + state.selectedTier.discount + '% off';

    const thumbEl = $('[data-bbdemo-cd-bundle-thumb]');
    if (thumbEl && state.selectedBox) {
      const box = products.find(x => x.id === state.selectedBox);
      thumbEl.innerHTML = box && box.img ? box.img : '';
    }

    const limit = state.selectedTier.qty;
    const original = state.basePrice * (limit / 6);
    const price = original * (1 - state.selectedTier.discount / 100);
    const giftPrice = state.giftBox ? state.giftBox.price : 0;
    const total = price + giftPrice;

    const cdPrice = $('[data-bbdemo-cd-price]');
    const cdStrike = $('[data-bbdemo-cd-strike]');
    const cdSubtotal = $('[data-bbdemo-cd-subtotal]');
    const cdDisc = $('[data-bbdemo-cd-disc]');
    const cdGrand = $('[data-bbdemo-cd-grand]');
    if (cdPrice) cdPrice.textContent = '£' + price.toFixed(2);
    if (cdStrike) cdStrike.textContent = '£' + original.toFixed(2);
    if (cdSubtotal) cdSubtotal.textContent = '£' + (original + giftPrice).toFixed(2);
    if (cdDisc) cdDisc.textContent = '−£' + (original - price).toFixed(2);
    if (cdGrand) cdGrand.textContent = '£' + total.toFixed(2);

    const cd = $('[data-bbdemo-cd]');
    const cdOverlay = $('[data-bbdemo-cd-overlay]');
    if (cd) cd.classList.add('is-active');
    if (cdOverlay) cdOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    showToast('Bundle added to cart', 'success');
  }

  function closeCartDrawer() {
    const cd = $('[data-bbdemo-cd]');
    const cdOverlay = $('[data-bbdemo-cd-overlay]');
    if (cd) cd.classList.remove('is-active');
    if (cdOverlay) cdOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
  const cdClose = $('[data-bbdemo-cd-close]');
  if (cdClose) cdClose.addEventListener('click', closeCartDrawer);
  const cdOverlay = $('[data-bbdemo-cd-overlay]');
  if (cdOverlay) cdOverlay.addEventListener('click', closeCartDrawer);

  let toastTimeout;
  function showToast(msg, type) {
    const el = $('[data-bbdemo-toast]');
    if (!el) return;
    el.textContent = msg;
    el.className = 'bbdemo__toast is-show' + (type ? ' is-' + type : '');
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => el.classList.remove('is-show'), 2400);
  }

  const sidebar = $('[data-bbdemo-sidebar]');
  const mobileBar = $('[data-bbdemo-mobile-bar]');
  const basketHeader = $('[data-bbdemo-basket-header]');

  function isMobileLayout() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function toggleSidebar() {
    if (!isMobileLayout() || !sidebar) return;
    var isOpen = sidebar.classList.toggle('is-expanded');
    if (isOpen) {
      animateSidebar(0, 400);
    } else {
      var sidebarHeight = 64;
      var peekTranslate = 100 - (sidebarHeight / sidebar.offsetHeight) * 100;
      animateSidebar(peekTranslate, 400);
    }
  }

  if (mobileBar) mobileBar.addEventListener('click', toggleSidebar);
  if (basketHeader) {
    basketHeader.addEventListener('click', () => {
      if (isMobileLayout()) toggleSidebar();
    });
  }

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (!addBtn.disabled && isMobileLayout() && sidebar) {
        sidebar.classList.remove('is-expanded');
      }
    });
  }

  window.addEventListener('resize', () => {
    if (!isMobileLayout() && sidebar) {
      sidebar.classList.remove('is-expanded');
    }
  });

  renderProducts();
  update();

  function getSectionWrapper(el) {
    var node = el;
    while (node && node !== document.body) {
      if (node.id && node.id.indexOf('shopify-section-') === 0) return node;
      node = node.parentElement;
    }
    return el;
  }

  var lastSectionState = null;
  var rafPending = false;
  var animFrameId = null;
  var animStartTime = 0;
  var animFrom = 100;
  var animTo = 100;
  var animDuration = 500;
  var currentTranslate = 100;
  var currentOpacity = 0;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function setSidebarStyle(translatePct, opacity) {
    if (!sidebar) return;
    currentTranslate = translatePct;
    currentOpacity = opacity;
    var transformStr = 'translate3d(0, ' + translatePct + '%, 0)';
    sidebar.style.transform = transformStr;
    sidebar.style.webkitTransform = transformStr;
    sidebar.style.opacity = opacity;
    sidebar.style.pointerEvents = opacity > 0.5 ? 'auto' : 'none';
  }

  function animateSidebar(toTranslate, duration) {
    if (animFrameId) cancelAnimationFrame(animFrameId);
    animFrom = currentTranslate;
    animTo = toTranslate;
    animDuration = duration;
    animStartTime = performance.now();

    function tick(now) {
      var elapsed = now - animStartTime;
      var t = Math.min(1, elapsed / animDuration);
      var eased = easeOutCubic(t);
      var translate = animFrom + (animTo - animFrom) * eased;
      var opacity = translate >= 99.5 ? 0 : 1;
      setSidebarStyle(translate, opacity);
      if (t < 1) {
        animFrameId = requestAnimationFrame(tick);
      } else {
        animFrameId = null;
      }
    }
    animFrameId = requestAnimationFrame(tick);
  }

  function applySectionState() {
    rafPending = false;
    var wrapper = getSectionWrapper(root);
    var r = wrapper.getBoundingClientRect();
    var vh = window.innerHeight;
    var sectionInView;
    if (isMobileLayout()) {
      var sidebarHeight = 64;
      var sidebarTop = vh - sidebarHeight;
      sectionInView = r.top < vh && r.bottom > sidebarTop;
    } else {
      sectionInView = r.top < vh * 0.5 && r.bottom > 80;
    }
    if (sectionInView === lastSectionState) return;
    lastSectionState = sectionInView;
    if (sectionInView) {
      document.body.classList.add('bbdemo-section-active');
      if (isMobileLayout() && sidebar) {
        var peekTranslate = 100 - (64 / sidebar.offsetHeight) * 100;
        animateSidebar(peekTranslate, 500);
      }
    } else {
      document.body.classList.remove('bbdemo-section-active');
      if (sidebar) sidebar.classList.remove('is-expanded');
      if (isMobileLayout()) {
        animateSidebar(100, 400);
      }
    }
  }

  function checkSectionVisibility() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(applySectionState);
  }

  window.addEventListener('scroll', checkSectionVisibility, { passive: true });
  window.addEventListener('resize', checkSectionVisibility, { passive: true });
  checkSectionVisibility();
})();